"use client"

import { configureStore } from '@reduxjs/toolkit'
import { reducer as aiAssistantReducer } from 'features/ai-assistant/model/slice/aiAssistantSlice'
import assetsReducer from 'features/assets/model/slice/assetsSlice'
import boardsReducer from 'features/boards/model/slice/boardsSlice'
import { appReducer } from 'features/common/model/slice/appSlice'
import { modalReducer } from 'features/common/model/slice/moadlSlice'
import notificationsReducer from 'features/common/model/slice/notificationsSlice'
import searchReducer from 'features/common/model/slice/searchSlice'
import { sharingReducer } from 'features/common/model/slice/sharingSlice'
import dragReducer from 'features/common/model/slice/dragSlice'
import multiSelectReducer from 'features/common/model/slice/multiSelectSlice'
import { dropzoneReducer } from 'features/dropzone/dropzoneSlice'
import { fileVersionsReducer } from 'features/file-versions/model/slice/fileVersionsSlice'
import { filesPreviewReducer } from 'features/files-preview/model/slice/filesPreviewSlice'
import filesUploadingReducer from 'features/files-uploading/model/slice/filesUploadingSlice'
import { publicLinkFilesReducer } from 'features/public-link-files/model/slice/publicLinkFilesSlice'
import { recentlyDeletedReducer } from 'features/recently-deleted/model/slice/recentlyDeletedSlice'
import familyReducer from 'features/team/model/slice/teamSlice'
import userReducer from 'features/user/model/slice/userSlice'
import { userAgreementReducer } from 'features/user/user-agreement/model/slice/userAgreementModalSlice'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    assets: assetsReducer,
    boards: boardsReducer,
    family: familyReducer,
    filesUploading: filesUploadingReducer,
    userAgreement: userAgreementReducer,
    filesPreview: filesPreviewReducer,
    dropzone: dropzoneReducer,
    sharing: sharingReducer,
    publicLinkFiles: publicLinkFilesReducer,
    fileVersions: fileVersionsReducer,
    search: searchReducer,
    modal: modalReducer,
    notifications: notificationsReducer,
    recentlyDeleted: recentlyDeletedReducer,
    drag: dragReducer,
    multiSelect: multiSelectReducer,
    aiAssistant: aiAssistantReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Типизированные хуки
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
